import { Component, OnInit } from "@angular/core";
import { MsalService } from '@azure/msal-angular';

@Component({
    selector: 'app-redirect:not(p)',
    template: '',
    standalone: false
})
export class CustomRedirectComponent implements OnInit {
  
  constructor(private authService: MsalService) { }
  
  ngOnInit(): void {    
      this.authService.handleRedirectObservable().subscribe({
        error: (error) => {
          if(!(error.errorCode === 'access_denied'
            && error.errorMessage.startsWith('AADB2C90091: The user has cancelled entering self-asserted information.')))
            console.log(error);
        }
      });
  }  
}
